import { processHtmlAttributes } from "../../common/html-attributes/index.js";
static {}
$ const {
  class: inputClass,
  size,
  ...htmlInput
} = input;
<span ...processHtmlAttributes(htmlInput) class=["progress-spinner", size === "large" && "progress-spinner--large", inputClass] role="img">
  <if(size === "large")>
    <ebay-spinner-30-icon/>
  </if>
  <else-if(size === "small")>
    <ebay-spinner-20-icon/>
  </else-if>
  <else>
    <ebay-spinner-24-icon/>
  </else>
</span>